"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkNotification = exports.isNotification = void 0;
const __1 = require("..");
const NotificationType_1 = require("./NotificationType");
function isNotification(object) {
    return checkNotification(object).fulfilled;
}
exports.isNotification = isNotification;
function checkNotification(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, __1.check)(object, (0, __1.hasString)("id"), (0, __1.hasChoice)("resourceType", Object.values(__1.ResourceType)), (0, __1.hasString)("resourcePath").optional(), (0, __1.hasChoice)("type", Object.values(NotificationType_1.NotificationType)), (0, __1.hasNumber)("timestamp").integer(), (0, __1.hasMap)("data", (0, __1.isAny)()), (0, __1.hasBoolean)("isUnread")).withOptions(options).explain();
}
exports.checkNotification = checkNotification;
//# sourceMappingURL=Notification.js.map